import * as React from "react";

import { UitkPriceLockupAlign } from "uitk-react-price-lockup";

import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { PriceA11y } from "src/components/flexComponents/Hotels/utils/A11y/priceA11yInterface";
import { PriceLockupGetRates } from "./PriceLockupGetRates";
import { PriceLockupDefault } from "./PriceLockupDefaults";
import { useHotelsContext } from "src/components/flexComponents/Hotels/components/HotelsContext";

interface PriceLockupProps {
  hotel: Hotel;
  hotelLink: string;
  align?: UitkPriceLockupAlign;
  className?: string;
  priceA11y?: PriceA11y;
  strikeThroughPrice?: string;
  hasGetRatesText?: boolean;
}

export function validatePrice({ formattedPrice, hotelPrice }: Hotel) {
  return formattedPrice && hotelPrice && hotelPrice.value !== "0";
}

export const PriceLockup = (props: PriceLockupProps) => {
  const { model } = useHotelsContext();
  const isValidPrice = validatePrice(props.hotel);

  if ((!isValidPrice && !model.showGetPriceIfNoPrice) || !props.hasGetRatesText) {
    return null;
  }

  if (!isValidPrice && model.showGetPriceIfNoPrice) {
    return <PriceLockupGetRates className={props.className || ""} hotelLink={props.hotelLink} />;
  }

  return <PriceLockupDefault {...props} />;
};

export default PriceLockup;
